import Vue from "vue"
/* import product_collectionsApi from "../../api/product_collections" */
import utilsApi from "../../api/utils"
const initialObject = {
  _id: undefined,
  package_order: undefined,
  name: undefined,
  weight: undefined,
  length: undefined,
  width: undefined,
  height: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  packaging: undefined,
  zones: undefined,
  status: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]

// general state for the site

const initialState = {
  packagings: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  packagings: (state) => state.packagings,
  packagingsIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  packagingsError: (state) => state.error,
  packagings_Object: (state) => state.object,
  packagings_isNew: (state) => state.isNew,
  packagings_selected: (state) => state.selected
}
const actions = {
  async DELETE_packagings({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("packagings", object)
    if (apiResponse != null) {
      //commit("PACKAGINGS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_packagings", state.page)
      return true
    } else {
      commit("PACKAGINGS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_packagings({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_packagings", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_packagings", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_packagingsState({ commit }, payload) {
    commit("SET_packagings", payload)
    return true
  },
  async UPDATE_packagings({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("packagings", filtered)
    if (apiResponse != null) {
      commit("PACKAGINGS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_packagings", state.page)
      return true
    } else {
      commit("PACKAGINGS_ERROR")
      return false
    }
  },
  async CREATE_packagings({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("packagings", object)
    if (apiResponse != null) {
      commit("SET_packagings", {
        param: "object",
        value: apiResponse.packaging
      })
      dispatch("FETCH_PAGE_packagings", state.page)
      return true
    } else {
      commit("PACKAGINGS_ERROR")
      return false
    }
  },
  async FETCH_packagings({ commit }) {
    let apiResponse = await utilsApi.getObjects("packagings")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      //console.log("before state", apiResponse.packagings)
      commit("PACKAGINGS_SETTING", apiResponse)
      return true
    } else {
      commit("PACKAGINGS_ERROR")
      return false
    }
  },

  async FETCH_PAGE_packagings({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("packagings", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PACKAGINGS_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("PACKAGINGS_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_packagings({ commit }, payload) {
    commit("SET_OBJECT_PACKAGING", payload)
    return true
  },
  CLEAN_OBJECT_packagings({ commit }) {
    commit("SET_OBJECT_PACKAGING_INITIAL")
    return true
  },
  async CLEAN_STORE_packagings({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_packagings", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_packagings({ commit }, payload) {
    commit("SET_SELECTED_PACKAGINGS", payload)
    return true
  }
}
const mutations = {
  PACKAGINGS_SETTING: (state, { packagings, count = false, page }) => {
    //console.log(state)
    state.count = count || state.packagings.length
    state.page = page || state.page
    state.packagings = packagings
    state.fetched = true
    state.error = false
  },
  PACKAGINGS_ERROR: (state) => {
    state.packagings = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_PACKAGING: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_PACKAGING_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_PACKAGINGS: (state, selectedPackagings) => {
    state.selected = selectedPackagings
  },
  SET_packagings: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
